module.exports = __webpack_public_path__ + "img/page-28.f8253590.jpg";